var render = function render(){var _vm=this,_c=_vm._self._c;return _c('zul-modal',{ref:"modal",staticClass:"is-medium",attrs:{"id":"terms-modal","title":"Termos de uso","secondary":'Fechar'},on:{"secondary":function($event){return _vm.close()}}},[(_vm.showLoader)?_c('div',[_c('div',{staticClass:"loading"},[_vm._v(" Carregando... ")])]):_c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.terms)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }